import React from 'react'
import { Button, Card } from 'antd'
import EscalatedSubmissionsTable, { escalatedStatuses } from './EscalatedSubmissionsTable'
import { FlagOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { useState } from 'react'

const EscalatedSubmissionsCard = () => {
    const [filtersState, setFiltersState] = useState({})

    const toggleFiltersState = key => {
        setFiltersState({ ...filtersState, [key]: !filtersState[key] })
    }

    return (
        <Card
            className='mb-16'
            title='Escalated submissions'
            extra={
                <>
                    <Button
                        type={filtersState[escalatedStatuses.unexplainableUnresolved] ? 'primary' : 'text'}
                        onClick={() => {
                            toggleFiltersState(escalatedStatuses.unexplainableUnresolved)
                        }}
                        icon={
                            <QuestionCircleOutlined
                                style={{
                                    fontSize: 18,
                                    color: filtersState[escalatedStatuses.unexplainableUnresolved] ? 'white' : 'black',
                                }}
                            />
                        }
                        style={{ marginRight: 8 }}
                        title={'Unexplainable'}
                    />
                    <Button
                        type={filtersState[escalatedStatuses.manualUnresolved] ? 'primary' : 'text'}
                        onClick={() => {
                            toggleFiltersState(escalatedStatuses.manualUnresolved)
                        }}
                        icon={
                            <FlagOutlined
                                style={{
                                    fontSize: 18,
                                    color: filtersState[escalatedStatuses.manualUnresolved] ? 'white' : 'black',
                                }}
                            />
                        }
                        title={'Flagged by user'}
                    />
                </>
            }
        >
            <EscalatedSubmissionsTable filtersState={filtersState} />
        </Card>
    )
}

export default EscalatedSubmissionsCard
